// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { infoCardStyles } from "@sc/App/Widgets/InfoCard/InfoCard";
import ArrowRight from "@sc/XDL/Icons/ArrowRight";
import { color, hideElementOnPrint } from "@sc/XDL/Utilities";
import { css } from "styled-components";

infoCardStyles.wrapper = {
    css: css`
        border: 1px solid ${color("common.ui3")};
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        min-height: 100%;
        width: 100%;
        @media print {
            page-break-inside: avoid;
        }
    `,
};

infoCardStyles.imageWrapper = {
    css: css`
        width: 100%;
        height: 210px;
    `,
};

infoCardStyles.image = {
    css: css`
        &,
        img {
            width: 100%;
            max-height: 100%;
            object-fit: cover;
            border-radius: 4px 4px 0 0;
        }
    `,
};

infoCardStyles.cardContentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        padding: 16px 13px 13px;
        flex-grow: 1;
    `,
};

infoCardStyles.title = {
    size: 20,
    lineHeight: "28px",
    weight: "bold",
    color: "text.main",
    css: css`
        margin-bottom: 12px;
    `,
};

infoCardStyles.description = {
    size: 16,
    lineHeight: "26px",
    weight: "normal",
    color: "text.main",
    css: css`
        margin-bottom: 16px;
        &&& ${TypographyStyle} {
            margin-bottom: 0;
            font-size: 16px;
            line-height: 26px;
        }
    `,
};

infoCardStyles.link = {
    icon: {
        iconProps: {
            src: ArrowRight,
            mergeCss: true,
            color: "primary",
            css: css`
                margin-left: 8px;
                opacity: 0.66;
                svg {
                    width: 14px;
                    height: 16px;
                }
            `,
        },
        position: "right",
    },
    typographyProps: {
        size: 16,
        weight: "bold",
        ellipsis: true,
        css: css`
            letter-spacing: 0;
            line-height: 17px;
        `,
    },
    css: css`
        justify-content: flex-end;
        margin-top: auto;
        &:hover {
            & > ${IconWrapper}, & > ${TypographyStyle} {
                color: ${color("common.ui8")};
                opacity: 1;
                transition: none;
            }
        }
        @media print {
            ${hideElementOnPrint}
        }
    `,
};

infoCardStyles.button = {
    css: css`
        max-width: max-content;
        margin-top: auto;
    `,
};
